import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format any date string to DD-MM-YYYY.
 * Handles YYYY-MM-DD, YYYY-MM-DD HH:mm:ss, M/D/YYYY, etc.
 */
export function formatDate(dateStr: string): string {
  if (!dateStr) {return "";}
  // If already DD-MM-YYYY
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {return dateStr;}
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) {return dateStr;}
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

/**
 * Format datetime string to DD-MM-YYYY HH:mm:ss
 */
export function formatDateTime(dateStr: string): string {
  if (!dateStr) {return "";}
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) {return dateStr;}
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
}
